(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const SMS_SIGNUP_PATHS = ['/pages/sms-signup', '/pages/sms'];
  const SUPPORT_FORM_PATHS = ['/pages/contact', '/pages/contact-us'];
  const ENVELOPE_IMAGE_FILENAME = 'aurelius-sms-vault-envelope-hq.png';
  const ENVELOPE_IMAGE_URL = getThemeAssetUrl(ENVELOPE_IMAGE_FILENAME);
  const ENTRY_POPUP_DELAY_MS = 5000;
  const ENTRY_POPUP_SHOWN_KEY = 'aureliusEntryPopupShown';
  const ENTRY_POPUP_ACCEPTED_KEY = 'aureliusEntryPopupAccepted';
  let entryPopupShown = false;
  let entryPopupAccepted = false;

  function getThemeAssetUrl(filename) {
    const script = document.currentScript || document.querySelector('script[src*="aurelius-sms-popup.js"]');

    if (script && script.src) {
      return new URL(filename, script.src).toString();
    }

    return '/cdn/shop/files/' + filename;
  }

  function isPurchasePath() {
    return /^\/(products|cart|checkout|checkouts)(\/|$)/.test(window.location.pathname);
  }

  function isSupportFormPath() {
    const pathname = window.location.pathname.replace(/\/$/, '').toLowerCase();
    return SUPPORT_FORM_PATHS.indexOf(pathname) !== -1;
  }

  function isSmsSignupPath() {
    return SMS_SIGNUP_PATHS.indexOf(window.location.pathname.replace(/\/$/, '')) !== -1;
  }

  function shouldForceOpenSmsPopup() {
    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash.toLowerCase();

    return (
      isSmsSignupPath() ||
      params.get('sms') === '1' ||
      params.get('sms') === 'true' ||
      params.get('popup') === 'sms' ||
      hash === '#sms' ||
      hash === '#aurelius-discount-popup'
    );
  }

  function hasAcceptedEntryPopup() {
    try {
      return window.localStorage.getItem(ENTRY_POPUP_ACCEPTED_KEY) === 'true';
    } catch (error) {
      return entryPopupAccepted;
    }
  }

  function rememberEntryPopupAccepted() {
    entryPopupAccepted = true;

    try {
      window.localStorage.setItem(ENTRY_POPUP_ACCEPTED_KEY, 'true');
      window.sessionStorage.setItem(ENTRY_POPUP_SHOWN_KEY, 'true');
    } catch (error) {
      entryPopupShown = true;
    }

    const teaser = document.getElementById('aurelius-sms-teaser');
    if (teaser) teaser.hidden = true;
  }

  function rememberEntryPopupShown() {
    entryPopupShown = true;

    try {
      window.sessionStorage.setItem(ENTRY_POPUP_SHOWN_KEY, 'true');
    } catch (error) {}
  }

  function wasEntryPopupShown() {
    try {
      return window.sessionStorage.getItem(ENTRY_POPUP_SHOWN_KEY) === 'true';
    } catch (error) {
      return entryPopupShown;
    }
  }

  function suppressDefaultKlaviyoPopup() {
    document.body.classList.remove('klaviyo-prevent-body-scrolling');

    document.querySelectorAll('div[role="dialog"][aria-label="POPUP Form"]').forEach(function (dialog) {
      dialog.remove();
    });

    document.querySelectorAll('form[data-testid^="klaviyo-form"]').forEach(function (form) {
      const dialog = form.closest('div[role="dialog"]');
      if (dialog) dialog.remove();
    });

    Array.from(document.querySelectorAll('button'))
      .filter(function (button) {
        return button.textContent.trim().toLowerCase().includes('get 10% off');
      })
      .forEach(function (button) {
        const teaser = button.parentElement;
        if (teaser) teaser.remove();
      });
  }

  function ensureNotifyFallbackStyles() {
    if (document.getElementById('aurelius-notify-fallback-style')) return;

    const style = document.createElement('style');
    style.id = 'aurelius-notify-fallback-style';
    style.textContent =
      '.aurelius-notify-fallback{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:18px;background:rgba(0,0,0,.72);font-family:var(--font-body-family),Arial,sans-serif}' +
      '.aurelius-notify-fallback *{box-sizing:border-box}' +
      '.aurelius-notify-fallback[hidden]{display:none}' +
      '.aurelius-notify-card{position:relative;width:min(100%,380px);max-height:calc(100svh - 36px);overflow:auto;padding:34px 24px 28px;border:1px solid rgba(247,244,237,.12);border-radius:10px;background:#050505;color:#f7f4ed;box-shadow:0 24px 74px rgba(0,0,0,.48);display:flex;flex-direction:column;align-items:center;text-align:center}' +
      '.aurelius-notify-close{position:absolute;top:12px;right:12px;width:34px;height:34px;border:0;border-radius:999px;background:transparent;color:rgba(247,244,237,.58);font-family:Helvetica,Arial,sans-serif;font-size:24px;font-weight:300;line-height:1;cursor:pointer}' +
      '.aurelius-notify-envelope{display:block;width:min(150px,42vw);margin:0 auto 19px;filter:drop-shadow(0 18px 24px rgba(0,0,0,.34)) drop-shadow(0 0 22px rgba(247,244,237,.04));opacity:.96}' +
      '.aurelius-notify-envelope img{display:block;width:100%;height:auto}' +
      '.aurelius-notify-brand{margin:0;color:#f7f4ed;font-family:Helvetica,Arial,sans-serif;font-size:clamp(23px,6.5vw,30px);font-weight:500;line-height:1.04;text-transform:none;letter-spacing:-.03em;text-shadow:0 14px 32px rgba(0,0,0,.42)}' +
      '.aurelius-notify-kicker{display:block;margin:10px 0 0;color:rgba(247,244,237,.54);font-family:Helvetica,Arial,sans-serif;font-size:8px;font-weight:700;line-height:1.2;text-transform:uppercase;letter-spacing:.2em}' +
      '.aurelius-notify-offer{display:block;margin:8px 0 6px;color:#f7f4ed;font-family:Helvetica,Arial,sans-serif;font-size:clamp(22px,6.4vw,29px);font-weight:700;line-height:1;text-transform:uppercase;letter-spacing:.02em}' +
      '.aurelius-notify-subline{display:block;margin:0 auto;color:rgba(247,244,237,.74);font-family:Helvetica,Arial,sans-serif;font-size:12.5px;font-weight:400;line-height:1.4;max-width:292px;letter-spacing:0}' +
      '.aurelius-notify-rule{display:block;width:26px;height:1px;margin:14px auto 0;background:#8f1d1d;opacity:.62}' +
      '.aurelius-notify-form{display:grid;gap:11px;width:100%;margin:18px 0 0}' +
      '.aurelius-notify-input{width:100%;height:48px;padding:0 17px;border:1px solid rgba(247,244,237,.3);border-radius:999px;background:#0b0b0b;color:#f7f4ed;font-size:14px;text-align:left;outline:none;box-shadow:none}' +
      '.aurelius-notify-input:focus{border-color:rgba(247,244,237,.82);box-shadow:0 0 0 1px rgba(247,244,237,.12)}' +
      '.aurelius-notify-input::placeholder{color:rgba(247,244,237,.5);opacity:1}' +
      '.aurelius-notify-consent{margin:0 auto;color:rgba(247,244,237,.46);font-size:8px;line-height:1.34;max-width:318px}' +
      '.aurelius-notify-consent a{color:rgba(247,244,237,.76);font-weight:800;text-decoration:underline;text-underline-offset:2px}' +
      '.aurelius-notify-submit{display:grid;place-items:center;width:100%;max-width:100%;min-width:0;min-height:52px;padding:10px clamp(14px,4vw,24px);overflow:hidden;border:0;border-radius:999px;background:#f7f4ed;color:#050505!important;font-family:Helvetica,Arial,sans-serif;font-size:clamp(10px,2.8vw,11px);font-weight:800;line-height:1.05;cursor:pointer;text-transform:uppercase;letter-spacing:clamp(.08em,.35vw,.16em);text-align:center;text-decoration:none}' +
      '.aurelius-notify-submit__label{display:block;max-width:100%;color:#050505!important;overflow-wrap:anywhere;text-wrap:balance}' +
      '.aurelius-notify-submit__meta{display:block;margin-top:4px;color:#050505!important;opacity:.52!important;font-size:7.5px;font-weight:700;letter-spacing:.12em}' +
      '.aurelius-notify-submit[disabled]{opacity:.7;cursor:wait}' +
      '.aurelius-notify-confirm{display:none;width:100%;margin-top:20px;padding-top:20px;border-top:1px solid rgba(247,244,237,.12)}' +
      '.aurelius-notify-card[data-step="confirm"] .aurelius-notify-form{display:none}' +
      '.aurelius-notify-card[data-step="confirm"] .aurelius-notify-confirm{display:grid;gap:12px}' +
      '.aurelius-notify-confirm-title{margin:0;color:#f7f4ed;font-size:12px;font-weight:850;line-height:1.25;text-transform:uppercase;letter-spacing:.14em}' +
      '.aurelius-notify-confirm-copy{margin:0;color:rgba(247,244,237,.7);font-size:12px;line-height:1.45}' +
      '.aurelius-notify-status{min-height:16px;margin:0;color:rgba(247,244,237,.68);font-size:11px;line-height:1.3}' +
      '.aurelius-notify-status[data-state="error"]{color:#ffb7ad}' +
      '.aurelius-notify-status[data-state="success"]{color:#f7f4ed}' +
      '.aurelius-sms-teaser{position:fixed;right:14px;bottom:max(14px,env(safe-area-inset-bottom));z-index:900;display:flex;align-items:center;gap:8px;min-height:42px;padding:8px 12px 8px 14px;border:1px solid rgba(247,244,237,.16);border-radius:999px;background:#070707;color:#f7f4ed;box-shadow:0 12px 30px rgba(0,0,0,.28);font-family:var(--font-body-family),Arial,sans-serif;cursor:pointer}' +
      '.aurelius-sms-teaser[hidden]{display:none}' +
      '.aurelius-sms-teaser__dot{width:8px;height:8px;border-radius:999px;background:#8f1d1d;box-shadow:0 0 0 3px rgba(143,29,29,.18)}' +
      '.aurelius-sms-teaser__text{display:grid;gap:1px;text-align:left;line-height:1}' +
      '.aurelius-sms-teaser__offer{font-size:12px;font-weight:850;letter-spacing:.08em;text-transform:uppercase}' +
      '.aurelius-sms-teaser__label{color:rgba(247,244,237,.62);font-size:9px;font-weight:750;letter-spacing:.12em;text-transform:uppercase}' +
      '.aurelius-sms-teaser__close{width:22px;height:22px;display:grid;place-items:center;margin-left:1px;border:0;border-radius:999px;background:rgba(247,244,237,.08);color:rgba(247,244,237,.72);font-size:16px;line-height:1;cursor:pointer}' +
      '.aurelius-notify-decline{margin-top:12px;border:0;background:transparent;color:rgba(247,244,237,.46);font-family:Helvetica,Arial,sans-serif;font-size:10.5px;font-weight:500;line-height:1.2;cursor:pointer;letter-spacing:.01em;text-decoration:underline;text-underline-offset:4px;text-decoration-thickness:1px;text-decoration-color:rgba(247,244,237,.22)}' +
      '@media (max-width:749px){.aurelius-notify-fallback{place-items:stretch;padding:0;background:#050505}.aurelius-notify-card{width:100%;max-width:none;min-height:100svh;max-height:100svh;border:0;border-radius:0;box-shadow:none;padding:max(54px,calc(env(safe-area-inset-top) + 34px)) 24px max(24px,calc(env(safe-area-inset-bottom) + 22px));justify-content:center}.aurelius-notify-close{top:max(12px,env(safe-area-inset-top));right:14px}.aurelius-notify-envelope{width:min(164px,45vw);margin-bottom:20px}.aurelius-notify-brand{font-size:clamp(24px,6.8vw,31px)}.aurelius-notify-offer{font-size:clamp(22px,6.1vw,29px)}.aurelius-notify-form{margin-top:clamp(18px,3.8svh,28px)}.aurelius-notify-decline{margin-top:16px}}' +
      '@media (max-width:389px){.aurelius-notify-card{padding-left:20px;padding-right:20px}.aurelius-notify-envelope{width:146px}.aurelius-notify-offer{font-size:22px}.aurelius-notify-brand{font-size:23px}.aurelius-notify-subline{font-size:12px}}';
    document.head.appendChild(style);
  }

  function openAureliusNotifyFallback() {
    const existing = document.getElementById('aurelius-notify-fallback');
    if (existing) {
      existing.hidden = false;
      existing.querySelector('.aurelius-notify-submit')?.focus();
      return;
    }

    ensureNotifyFallbackStyles();

    const modal = document.createElement('div');
    modal.id = 'aurelius-notify-fallback';
    modal.className = 'aurelius-notify-fallback';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Join AURELIUS drop updates');

    modal.innerHTML =
      '<div class="aurelius-notify-card">' +
      '<button class="aurelius-notify-close" type="button" aria-label="Close">&times;</button>' +
      '<span class="aurelius-notify-envelope" aria-hidden="true"><img src="' +
      ENVELOPE_IMAGE_URL +
      '" alt="" loading="eager" decoding="async"></span>' +
      '<p class="aurelius-notify-brand">Enter the Vault</p>' +
      '<p class="aurelius-notify-kicker">Drop access</p>' +
      '<p class="aurelius-notify-offer">$39.99 FALL SALE · WAS $55</p>' +
      '<p class="aurelius-notify-subline">Fallen Thermal is on sale now. Shipping is calculated at checkout worldwide.</p>' +
      '<span class="aurelius-notify-rule" aria-hidden="true"></span>' +
      '<a class="aurelius-notify-submit" href="/products/black-thermal"><span class="aurelius-notify-submit__label">Shop Fallen Thermal</span><span class="aurelius-notify-submit__meta">Fall sale</span></a>' +
      '<button class="aurelius-notify-decline" type="button">No thanks</button>' +
      '</div>';

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('.aurelius-notify-close, .aurelius-notify-decline')) {
        modal.hidden = true;
        openAureliusEntryTeaser();
      }
    });

    document.body.appendChild(modal);
    modal.querySelector('.aurelius-notify-submit')?.addEventListener('click', rememberEntryPopupAccepted);
    modal.querySelector('.aurelius-notify-submit')?.focus();
  }

  function openAureliusEntryTeaser() {
    if (hasAcceptedEntryPopup()) return;
    if (isPurchasePath()) return;
    if (isSupportFormPath()) return;

    ensureNotifyFallbackStyles();

    const existing = document.getElementById('aurelius-sms-teaser');
    if (existing) {
      existing.hidden = false;
      return;
    }

    const teaser = document.createElement('button');
    teaser.id = 'aurelius-sms-teaser';
    teaser.className = 'aurelius-sms-teaser';
    teaser.type = 'button';
    teaser.setAttribute('aria-label', 'Open AURELIUS drop updates');
    teaser.innerHTML =
      '<span class="aurelius-sms-teaser__dot" aria-hidden="true"></span>' +
      '<span class="aurelius-sms-teaser__text"><span class="aurelius-sms-teaser__offer">$39.99</span><span class="aurelius-sms-teaser__label">Fall sale</span></span>' +
      '<span class="aurelius-sms-teaser__close" aria-hidden="true">&times;</span>';

    teaser.addEventListener('click', function (event) {
      event.preventDefault();

      if (event.target.closest('.aurelius-sms-teaser__close')) {
        teaser.hidden = true;
        return;
      }

      teaser.hidden = true;
      openAureliusNotifyFallback();
    });

    document.body.appendChild(teaser);
  }

  function openAureliusEntryPopup() {
    if (shouldForceOpenSmsPopup()) {
      openAureliusNotifyFallback();
      return;
    }

    if (isPurchasePath()) return;
    if (isSupportFormPath()) return;
    if (hasAcceptedEntryPopup()) return;

    if (wasEntryPopupShown()) {
      openAureliusEntryTeaser();
      return;
    }

    rememberEntryPopupShown();
    openAureliusNotifyFallback();
  }

  function openAureliusDiscountPopup(event) {
    const trigger = event.target.closest('a[href="#aurelius-discount-popup"]');
    if (!trigger) return;

    event.preventDefault();
    suppressDefaultKlaviyoPopup();

    const menuToggle = document.querySelector('.ah-menu-checkbox:checked');
    if (menuToggle) {
      menuToggle.checked = false;
      menuToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }

    openAureliusNotifyFallback();
  }

  const observer = new MutationObserver(function () {
    suppressDefaultKlaviyoPopup();
  });

  document.addEventListener('DOMContentLoaded', function () {
    suppressDefaultKlaviyoPopup();
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(openAureliusEntryPopup, ENTRY_POPUP_DELAY_MS);
  });

  document.addEventListener('click', openAureliusDiscountPopup);

  window.addEventListener('hashchange', function () {
    if (shouldForceOpenSmsPopup()) openAureliusNotifyFallback();
  });

  mobileQuery.addEventListener('change', function () {
    suppressDefaultKlaviyoPopup();
  });
})();
